import { useEffect, useState } from 'react';
import { checkForNewVersion, initializeVersion } from '../utils/versionCheck';

/**
 * Custom hook to check for new app versions periodically
 * @param {number} checkIntervalMs - How often to check (default: 5 minutes)
 * @returns {{hasNewVersion: boolean, checkNow: Function}}
 */
export function useVersionCheck(checkIntervalMs = 5 * 60 * 1000) {
    const [hasNewVersion, setHasNewVersion] = useState(false);

    const checkNow = async () => {
        const isNewVersion = await checkForNewVersion();
        setHasNewVersion(isNewVersion);
    };

    useEffect(() => {
        // Initialize version on mount
        initializeVersion();

        // Check immediately after a delay (to not block initial load)
        const initialCheckTimer = setTimeout(checkNow, 30000); // Check after 30 seconds

        // Then check periodically
        const intervalId = setInterval(checkNow, checkIntervalMs);

        // Dev helper: expose check function globally for testing
        if (import.meta.env.DEV) {
            window.__forceVersionCheck = checkNow;
            window.__simulateNewVersion = () => setHasNewVersion(true);
        }

        return () => {
            clearTimeout(initialCheckTimer);
            clearInterval(intervalId);
        };
    }, [checkIntervalMs]);

    return { hasNewVersion, checkNow };
}
